// import React from 'react'
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomTable from "../../../../components/common/CustomTable";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useDispatch, useSelector } from "react-redux";
import { locationMasterListAsync } from "../../../../redux/features/location-master/listLocationMasterSlice";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { BsPencilSquare } from "react-icons/bs";
import { changeStatus } from "../../../../Api/dispatch/location-dispatch";

export default function LocationMasterList() {
   const dispatch = useDispatch();
   const locationMasterList = useSelector((state) => state.locationMasterListSlice.data);
   const [records, setRecords] = useState([]);

   const [isActiveLoading, setIsActiveLoading] = useState({
      id: "",
      status: false,
   });

   const navigate = useNavigate();

   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         locationMasterListAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               toast.error(error);
            },
         })
      );
   }, []);

   useEffect(() => {
      if (locationMasterList) setRecords(locationMasterList);
   }, [locationMasterList]);

   // Handle active inactive
   const handleActiveInactive = (location) => {
      setIsActiveLoading({ id: location?.id, status: true });
      changeStatus({ id: location?.id, status: location?.is_active === "1" ? "0" : "1" })
         .then((res) => {
            setIsActiveLoading({ id: location?.id, status: false });
            dispatch(locationMasterListAsync({}));
            toast.success(
               `location ${location?.is_active === "1" ? "deactivated" : "activated"}`
            );
         })
         .catch((error) => {
            setIsActiveLoading({ id: location?.id, status: false });
            toast.error(
               `Failed to ${
                  location?.is_active === "1" ? "deactivate" : "activate"
               } location`
            );
         });
   };

   const columns = [
      {
         name: "Location Person Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button
                     className="btn"
                     onClick={() => navigate(`/location-master/Edit/${row.id}`)}
                  >
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={row?.is_active === "1"}
                     onChange={() => handleActiveInactive(row)}
                     isLoading={isActiveLoading.id === row?.id && isActiveLoading.status}
                  />
               </div>
            );
         },
      },
   ];

   const handleFilter = (e) => {
      const searchText = e.target.value.toLowerCase();
      const newData = locationMasterList?.filter((item) => {
         return item?.name?.toLowerCase().includes(searchText);
      });
      setRecords(newData);
   };

   return (
      <div>
         <BodyHeader title="Location Master List" />
         <div className="px-3">
            <div className="d-flex justify-content-start">
               <CustomInput
                  inputType="text"
                  placeholder="Search..."
                  id="search"
                  onChange={(e) => handleFilter(e)}
               />
            </div>
            <CustomTable columns={columns} data={records} />
         </div>
      </div>
   );
}
